var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28954",
    "data-name": "Group 28954",
    transform: "translate(-21 -634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-bell",
    "data-name": "Icon feather-bell",
    transform: "translate(18.5 632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38141",
    "data-name": "Path 38141",
    d: "M18,8.4a5.4,5.4,0,1,0-10.8,0c0,6.3-2.7,8.1-2.7,8.1H20.7S18,14.7,18,8.4",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38142",
    "data-name": "Path 38142",
    d: "M18.52,31.5a1.8,1.8,0,0,1-3.115,0",
    transform: "translate(-4.361 -11.397)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    transform: "translate(21 634)",
    fill: "#fcfcfc",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotification);
export default __webpack_public_path__ + "static/media/profile-notification.547c1385c77c8b50d60a7f2c74f712fa.svg";
export { ForwardRef as ReactComponent };